import { render, staticRenderFns } from "./addSystem.vue?vue&type=template&id=4d7d5835&scoped=true&"
import script from "./addSystem.vue?vue&type=script&lang=js&"
export * from "./addSystem.vue?vue&type=script&lang=js&"
import style0 from "./addSystem.vue?vue&type=style&index=0&id=4d7d5835&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7d5835",
  null
  
)

export default component.exports